import { ConfigurationTypes } from '../../../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../../../vendor_core/core/src/managers/ConfigManager';
import IAuthorizationData from '../../../../vendor_core/core/src/server/data/IAuthorizationData';
import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';

export default class CRCConfigDataParser implements IBaseDataParser<IAuthorizationData> {
    public check(data: any): boolean {
        return data && data.config;
    }

    public parse(data: any): IAuthorizationData[] {
        ConfigManager.getConfig(ConfigurationTypes.GAME).parseRTP(data.config.rtp);
        let rtp = ConfigManager.getConfig(ConfigurationTypes.GAME).getRTP();
        const result: IAuthorizationData = {
            rtp: rtp
        };

        return [result];
    }
}
